import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Clear any pre-rendered SEO content before React mounts
const seoContent = document.getElementById("seo-content");
if (seoContent) seoContent.remove();

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
